import * as currencies from '@dinero.js/currencies';
import { Currency } from 'dinero.js';

import { logError } from '@/imports/logging/ClientLogger';

const currencyMap = currencies as { [key: string]: Currency<number> };

const getCurrency = (code: string): Currency<number> | undefined => {
  return currencyMap[code.toUpperCase()];
};

export const getCurrencyFromCurrencyCode = (code: string): Currency<number> => {
  return (
    getCurrency(code) ??
    (() => {
      logError(new Error(`Unsupported currency code: ${code}`));
      return currencies.USD;
    })()
  );
};
